import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import styles from "../../styles/public/selection-bar.module.css";

const SelectionBar = ({ service, date, time, onEditStep, editable = true }) => {
    const handleEditStep = (step) => {
        if (onEditStep) {
            onEditStep(step);
        }
    };

    return (
        <Container className={styles["current-selection"]}>
            <Row className={styles["selection-items"]}>
                <Col xs="auto">
                    <small>Current selection:</small>
                </Col>
                {service && (
                    <Col xs="auto" className={styles["selection-text"]}>
                        <strong>{service.title}</strong>
                        {editable && <Button
                            color="link"
                            className={styles["edit-button"]}
                            onClick={() => handleEditStep(1)}
                        >
                            <small>Change</small>
                        </Button>}
                    </Col>
                )}
                {date && (
                    <Col xs="auto" className={styles["selection-text"]}>
                        <strong>{date} {time && `at ${time}`}</strong>
                        {editable && <Button
                            color="link"
                            className={styles["edit-button"]}
                            onClick={() => handleEditStep(2)}
                        >
                            <small>Change</small>
                        </Button>}
                    </Col>
                )}

            </Row>
        </Container>
    );
};

export default SelectionBar;
